// extracted by mini-css-extract-plugin
module.exports = {"header":"header___1hJkD","spacer":"spacer___23ouJ","logo":"logo___37Ka5"};